import React from 'react';
import { CustomGridItem } from "./CustomGridItem.js";
import { Grid } from "../../../grid/Grid.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function CustomGrid({
  element,
  control,
  isFormDisabled,
  isLoading,
  useSmallFields,
  showCheckmark = false
}) {
  return /*#__PURE__*/_jsx(Grid, {
    ...element.componentProps,
    children: element.componentProps.children.map((child, index) => /*#__PURE__*/_jsx(CustomGridItem, {
      child: child,
      index: index,
      showCheckmark: showCheckmark,
      control,
      isFormDisabled,
      isLoading,
      useSmallFields
    }, index))
  });
}